import { faker } from '@faker-js/faker';
import { DateTime } from 'luxon';

import { brandedId } from '../BrandedIds';
import { type PaymentConfig } from '../loan/PaymentConfig';

const DEFAULT_DATE = DateTime.now().minus({ months: 1 }).startOf('month').toJSDate();

export const paymentConfig = (overrides?: Partial<PaymentConfig>): PaymentConfig => ({
  id: brandedId('PaymentConfigId'),
  source: 'initial',
  createdAt: DEFAULT_DATE,
  effectiveDate: DEFAULT_DATE,
  type: 'fixed',
  isInterestOnly: false,
  monthlyPrincipalAndInterestTotal: faker.number.float({ multipleOf: 0.01, min: 200, max: 2000 }),
  monthlyInterestRate: faker.number.float({ multipleOf: 0.001, min: 0.01, max: 0.11 }),
  ...overrides,
});
